<template>
	<div class="carousel-wrap" id="carousel">		
		<transition-group tag='ul' class="slide-ul" name="list">
			<li v-for="(list,index) in slideList" :key='list' v-show="index===currentIndex" @mouseenter="stop(index)" @mouseleave="go(index)">
				<a :href="list.clickUrl">
					<img :src="list.image" :alt="list.desc"></img>
				</a>
			</li>
		</transition-group>
		<div class="carousel-items">
		  <span v-for="(item,index) in slideList.length"   :class="{'active':index===currentIndex}" @mouseover="onChange(index)">
		  	
		  </span>
	    </div>
	    	   
	</div>	
</template>

<script>
	export default{
		data(){
			return {
				slideList:[
				  {
				  	'clickUrl':'#',
				  	'desc':'第一张图片',
				  	'image':require('../assets/img/swipe/picture1.jpg')
				  },
				  {
				  	'clickUrl':'#',
				  	'desc':'第二张图片',
				  	'image':require('../assets/img/swipe/picture2.jpg')
				  },
				  {
				  	'clickUrl':'#',
				  	'desc':'第三张图片',
				  	'image':require('../assets/img/swipe/picture3.jpg')
				  },				   
				],
				currentIndex:0,
				timer:''
			}
		},
		mounted(){
			this.go(this.currentIndex);
		},
		methods:{
			go(index){
				console.log(index);
				this.timer=setInterval( () =>{
					this.auto();
				},2500);
			},
			stop(index){
				console.log(index);
				clearInterval(this.timer)
			},
			onChange(index){
				this.currentIndex = index;
				console.log(index);
			},
			auto(){
				console.log('auto');
				this.currentIndex++;
				if( this.currentIndex>this.slideList.length-1){
					this.currentIndex=0;
				}
			}
		}
	}
</script>

<style>
.carousel-wrap {
   height: 453px;
   width: 100%;
   overflow: hidden;
   background-color: #fff;
   border-radius: 10px;
   margin-bottom: 20px;
}

.slide-ul {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide-ul li {
  position: absolute;
  width: 100%;
  height: 100%;
}

img {
  width: 100%;
  height: 100%;
}

.carousel-items {
  position: absolute;
  z-index: 10;
  top: 430px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 0;
}

.carousel-items span {
  display: inline-block;
  height: 6px;
  width: 30px;
  margin: 0 3px;
  background-color: #b2b2b2;
  cursor: pointer;
}
.carousel-items .active {
  background-color: orange;
}

.list-enter-to {
  transition: all 1s ease;
  transform: translateX(0);
}

.list-leave-active {
  transition: all 1s ease;
  transform: translateX(-100%)
}

.list-enter {
  transform: translateX(100%)
}

.list-leave {
  transform: translateX(0)
}
</style>


// WEBPACK FOOTER //
// src/components/slide.vue